import React from 'react';
import axios from 'axios';

export const searchDocumentSendHistories = (param: string) => {
  return axios
    .get(`/api/v1/get/document/send/histories${param}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        return err.response.data;
      } else {
        return err.response;
      }
    });
};
